// extracted by mini-css-extract-plugin
export default {"guide-scroller":"LandlordsPage_guide-scroller__BiXSZ","steps-container":"LandlordsPage_steps-container__dRiA7"};